import api from 'service/api'
import changeCaseKeys from 'helpers/changeCase/keys'
import { TRAINING_AUTH_TOKEN, TRAINING_PORTAL_TOKEN } from 'service/constants'

const trainingPortalAPI = api.create('trainingPortal', false)

const resolveLink = async (token) =>
  trainingPortalAPI.get('/auth/resolve_link', { params: { token } })

const requestCode = async (data) =>
  trainingPortalAPI.post('/auth/request_code', data)

const verifyCode = async (data) =>
  trainingPortalAPI.post('/auth/verify_code', data)

const setToken = (token) => localStorage.setItem(TRAINING_AUTH_TOKEN, token)

const getToken = () => {
  const token = localStorage.getItem(TRAINING_AUTH_TOKEN)
  return token === 'null' ? null : token
}

const removeToken = () => localStorage.removeItem(TRAINING_AUTH_TOKEN)

const setPortalToken = (token) =>
  localStorage.setItem(TRAINING_PORTAL_TOKEN, token)

const getPortalToken = () => {
  const token = localStorage.getItem(TRAINING_PORTAL_TOKEN)
  return token === 'null' ? null : token
}

const removePortalToken = () => localStorage.removeItem(TRAINING_PORTAL_TOKEN)

const decodeToken = (token) => {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    return changeCaseKeys.camelCase(JSON.parse(atob(base64)))
  } catch {
    return null
  }
}

const isAuthenticated = () => {
  const token = getToken()
  if (!token) return false
  const payload = decodeToken(token)
  if (!payload) return false
  return payload.exp > Date.now() / 1000
}

const logout = () => {
  const portalToken = getPortalToken()
  removeToken()
  if (portalToken) {
    window.location.href = `/training/${portalToken}`
  }
}

export default {
  decodeToken,
  getPortalToken,
  getToken,
  isAuthenticated,
  logout,
  removePortalToken,
  removeToken,
  requestCode,
  resolveLink,
  setPortalToken,
  setToken,
  verifyCode,
}
